import React, { useState } from "react";
import SyntaxHighlighter from "react-syntax-highlighter";
import { defaultStyle } from "react-syntax-highlighter/dist/esm/styles/hljs";

interface props {
  codeBlackText: string;
  code: string;
  codeLanguage: string;
}

export default function CodeBlock(props: props) {
  const [copy, setCopy] = useState(false);

  return (
    <div
      className=" grid place-items-center"
      style={{ backgroundColor: "#282C34" }}
    >
      <div className="bg-[#3a404d] rounded-md overflow-hidden">
        <div className="d-flex flex-row justify-content-between bg-primary px-4 text-white text-xs py-2">
          <p className="my-auto">{props.codeBlackText}</p>
          {!copy ? (
            <button
              onClick={() => {
                navigator.clipboard.writeText(props.code);
                setCopy(true);
                setTimeout(() => {
                  setCopy(false);
                }, 3000);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                height={20}
                width={22}
              >
                <title>content-paste</title>
                <path d="M11.5,1C12.71,1 13.72,1.86 13.95,3H17C18.66,3 20,4.34 20,6V19C20,20.66 18.66,22 17,22H6C4.34,22 3,20.66 3,19V6C3,4.34 4.34,3 6,3H9.05C9.28,1.86 10.29,1 11.5,1M12.91,3C12.71,2.42 12.15,2 11.5,2C10.85,2 10.29,2.42 10.09,3H12.91M6,4C4.9,4 4,4.9 4,6V19C4,20.1 4.9,21 6,21H17C18.1,21 19,20.1 19,19V6C19,4.9 18.1,4 17,4H16V7H7V4H6M8,4V6H15V4H8Z" />
              </svg>
              <span className="pl-2 text-white">Copy code</span>
            </button>
          ) : (
            <button>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                height={20}
                width={22}
              >
                <title>check</title>
                <path d="M18.9,8.1L9,18L4.05,13.05L4.76,12.34L9,16.59L18.19,7.39L18.9,8.1Z" />
              </svg>
              <span className="pl-2 text-white">Copy code</span>
            </button>
          )}
        </div>
        <SyntaxHighlighter
          language={props.codeLanguage}
          style={defaultStyle}
          showLineNumbers={true}
          wrapLongLines={true}
          customStyle={{
            padding: "25px"
          }}
        >
          {props.code}
        </SyntaxHighlighter>
      </div>
    </div>
  );
}
